import { render } from "./ViewPublicationDetails.vue.js?vue&type=template&id=40dfe404&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationDetails.vue?vue&type=template&id=40dfe404&scoped=true"
import script from "./ViewPublicationDetails.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationDetails.vue?vue&type=script&lang=js"
export * from "./ViewPublicationDetails.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationDetails.vue?vue&type=script&lang=js"

import "./ViewPublicationDetails.vue.scss?vue&type=style&index=0&id=40dfe404&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationDetails.vue?vue&type=style&index=0&id=40dfe404&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dfe404"],['__file',"src/Web/scripts/pages/publication/ViewPublicationDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40dfe404"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40dfe404', __exports__)) {
    api.reload('40dfe404', __exports__)
  }
  
  module.hot.accept("./ViewPublicationDetails.vue.js?vue&type=template&id=40dfe404&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ViewPublicationDetails.vue?vue&type=template&id=40dfe404&scoped=true", () => {
    api.rerender('40dfe404', render)
  })

}


export default __exports__